// extracted by mini-css-extract-plugin
export default {"root":"loading_root__XLa7q","img":"loading_img__9of2w"};